module.exports = __webpack_public_path__ + "static/media/menu1_cont_04.6f796c5c.png";